import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, TrophyIcon, CheckIcon } from 'lucide-react';
export function UpsellSection() {
  return <section className="w-full py-20 md:py-24 px-4 bg-light-coral border-y border-secondary-coral/20" data-id="element-308">
      <div className="max-w-4xl mx-auto" data-id="element-309">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-310">
          <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6 shadow-inner" data-id="element-311">
            <ZapIcon className="w-8 h-8 text-amber-500 fill-amber-500" data-id="element-312" />
          </div>

          <h2 className="text-sm md:text-base font-bold tracking-widest text-secondary-coral uppercase mb-4" data-id="element-313">
            MOMENTO — ANTES DE CONFIRMAR TU COMPRA
          </h2>

          <h3 className="text-3xl md:text-4xl font-heading font-bold text-text-heading mb-6" data-id="element-314">
            Agregá esto a tu pack y completá el sistema en un solo paso
          </h3>

          <div className="text-lg md:text-xl text-text-body space-y-4 max-w-2xl mx-auto" data-id="element-315">
            <p data-id="element-316">El Método te da el conocimiento y las estrategias.</p>
            <p className="font-bold text-text-heading" data-id="element-317">
              Pero, ¿qué pasa cuando llega la crisis en tiempo real?
            </p>
            <p data-id="element-318">Leíste todo. Entendiste todo.</p>
            <p data-id="element-319">
              Y cuando tu hijo tira el plato a las 8 de la noche... te quedás en
              blanco.
            </p>
            <p className="italic" data-id="element-320">¿Por qué?</p>
            <p data-id="element-321">
              Porque tener la información y tener la herramienta en la mano en
              el momento exacto son dos cosas distintas.
            </p>
            <p data-id="element-322">Y la mayoría de las familias solo tienen la primera.</p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="bg-white rounded-2xl shadow-xl overflow-hidden border-2 border-amber-300 relative" data-id="element-323">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-amber-300 via-amber-400 to-amber-300" data-id="element-324"></div>

          <div className="p-8 md:p-10" data-id="element-325">
            <div className="flex items-center justify-center mb-6" data-id="element-326">
              <TrophyIcon className="w-10 h-10 text-amber-500 mr-4" data-id="element-327" />
              <h4 className="text-sm font-bold tracking-widest text-amber-600 uppercase" data-id="element-328">
                COMPLETÁ TU MÉTODO CON:
              </h4>
            </div>

            <div className="text-center mb-10" data-id="element-329">
              <h3 className="text-3xl md:text-4xl font-heading font-bold text-text-heading mb-2" data-id="element-330">
                KIT DE IMPLEMENTACIÓN RÁPIDA
              </h3>
              <p className="text-lg text-text-body font-medium" data-id="element-331">
                Las Herramientas para Usar en Tiempo Real
                <br className="hidden md:block" data-id="element-332" /> Para la Familia que Quiere
                Resultados desde la Primera Cena
              </p>
            </div>

            <ul className="space-y-5 max-w-2xl mx-auto" data-id="element-333">
              {[{
              title: '12 Tarjetas SOS de Crisis',
              desc: 'La respuesta exacta en el momento exacto. Pegadas en tu heladera. Sin pensar. Sin improvisar.'
            }, {
              title: 'Tablero de Progreso Visual',
              desc: 'Para medir los micro-avances semana a semana y no abandonar el proceso cuando la duda aparece.'
            }, {
              title: 'Guía Rápida de los 7 Días',
              desc: 'Los 4 tomos condensados en 2 páginas para llevar a la cena. Sin buscar en el celular.'
            }, {
              title: 'Kit de Comunicación Familiar',
              desc: 'La carta para los abuelos. El instructivo para la maestra. La tarjeta para la niñera. Para que todos empujen para el mismo lado.'
            }, {
              title: 'Diario de Regulación Parental',
              desc: 'Porque el adulto regulado es la herramienta terapéutica más poderosa que existe. Y nadie trabaja eso.'
            }].map((item, i) => <li key={i} className="flex items-start" data-id="element-334">
                  <div className="mt-1 bg-amber-100 rounded-full p-1 mr-4 flex-shrink-0" data-id="element-335">
                    <CheckIcon className="w-4 h-4 text-amber-600" data-id="element-336" />
                  </div>
                  <div data-id="element-337">
                    <span className="font-bold text-text-heading" data-id="element-338">
                      {item.title}
                    </span>
                    <span className="text-text-body mx-2" data-id="element-339">—</span>
                    <span className="text-text-body" data-id="element-340">{item.desc}</span>
                  </div>
                </li>)}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>;
}